import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { siteConfig } from "@/config/siteConfig";

const productLinks = [
  { label: "Worlds", to: "/#worlds", id: "worlds" },
  { label: "Flagship features", to: "/#features", id: "features" },
  { label: "Pricing", to: "/#pricing", id: "pricing" },
  { label: "Get the app", to: "/#app", id: "app" },
];

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy", id: "privacy" },
  { label: "Terms of Service", to: "/terms", id: "terms" },
  { label: "Refund & Cancellation", to: "/refund-policy", id: "refund" },
  { label: "Account Deletion", to: "/account-deletion", id: "account-deletion" },
  { label: "AI Disclaimer", to: "/ai-disclaimer", id: "ai-disclaimer" },
];

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white" data-testid="footer">
    <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
            {siteConfig.brand.tagline} Study smarter. Create better. Work faster —
            with one AI assistant on Android.
          </p>
          <p className="mt-6 max-w-sm text-xs leading-relaxed text-slate-500">
            ORIVA uses artificial intelligence to generate responses. AI output may be
            inaccurate or incomplete — always verify important information.
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Product</p>
          <ul className="mt-5 flex flex-col gap-3">
            {productLinks.map((link) => (
              <li key={link.id}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.id}`}
                  className="text-sm text-slate-600 transition-colors duration-200 hover:text-slate-900"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Legal</p>
          <ul className="mt-5 flex flex-col gap-3">
            {legalLinks.map((link) => (
              <li key={link.id}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.id}`}
                  className="text-sm text-slate-600 transition-colors duration-200 hover:text-slate-900"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Support</p>
          <ul className="mt-5 flex flex-col gap-3">
            <li>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="text-sm text-slate-600 transition-colors duration-200 hover:text-slate-900"
              >
                Contact us
              </Link>
            </li>
            <li>
              <a
                href={`mailto:${siteConfig.contact.supportEmail}`}
                data-testid="footer-link-email"
                className="text-sm text-slate-600 transition-colors duration-200 hover:text-slate-900"
              >
                {siteConfig.contact.supportEmail}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-slate-200 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} {siteConfig.contact.businessName}. All rights reserved.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
          Study · Create · Work
        </p>
      </div>
    </div>
  </footer>
);
